import React from "react"
import { StaticQuery, graphql } from "gatsby"

import PostLink from "./post-link"


export default function RelatedBlogs() {
  return (
    <StaticQuery
      query={graphql`
      query {
        allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date]}) {
          edges {
            node {
              id
              excerpt(pruneLength: 250)
              frontmatter {
                date(formatString: "MMMM DD, YYYY")
                slug
                title
                featuredBlogImage {
                    childImageSharp {
                        fluid(maxWidth: 600, maxHeight: 400) {
                        ...GatsbyImageSharpFluid
                        }
                    }
                }
              }
            }
          }
        }
      }`
      }
      render={data => 
       {
          const Posts = data.allMarkdownRemark.edges
            .filter(edge => !!edge.node.frontmatter.date) // You can filter your posts based on some criteria
            .map(edge => (
                <div className="col-sm-4">
                <article className="feature feature-1">
                    <a href="#" className="block"> <img alt="Image" src={edge.node.frontmatter.featuredBlogImage.childImageSharp.fluid.src}/></a>
                    <div className="feature__body boxed boxed--border"> <span>{edge.node.frontmatter.date}</span>
                        <PostLink key={edge.node.id} post={edge.node} /> </div>
                </article>
            </div>    
            
                
                ))
          return (
            <div className="main-container">
                <div className="container">
                    <div className="row">
                        {Posts}
                    </div>
                </div>
            </div>
          )
      }
    }/>
  )
}

